import styled from "styled-components";

export const Nav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 120px;
  height: 80px;
  background-color: #2a2a2a;
  top: 0;
  z-index: 100;
  // position: fixed;
  width: 100vw;

  p {
    font: normal bold 16px "Roboto";
    color: #fff;
  }
  div.nav-items-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 80%;
  }
  img.onboard-logo {
    height: 75px;
  }

  div.no-dropdown {
    // width: 100%;
    display: flex;
    align-items: center;
  }

  @media all and (max-width: 991px) {
    padding: 12px 48px;
    flex-direction: row;
    height: 64px;
    padding: 0 75px 0 32px;

    img.onboard-logo {
      height: 60px;
    }

    div.nav-items-container {
      flex-direction: row;
      width: 80%;
      align-items: center;
      justify-content: space-around;

      div.no-dropdown {
        width: 100%;
        justify-content: space-evenly;
      }
    }
  }
`;

export const NavItem = styled.div`
  display: ${(props) => (props.visible ? "none" : "inherit")};
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 50px;
  width: 200px;
  cursor: pointer;
  padding: 8px 20px;

  i {
    margin-right: 20px;
    font-size: 30px;
    color: #acff24;
  }
  p {
    margin-bottom: 0;
    margin-left: 0;
    text-transform: uppercase;
    font-style: italic;
    font-size: 18px;
  }

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #fff;
    width: 100%;
    justify-content: flex-start;

    i {
      margin-right: 20px;
      font-size: 30px;
      color: #acff24;
    }
  }

  &:hover {
    // background-color: #4a4a4a;
    p {
      color: #acff24;
    }
    i {
      color: #3ee9f7;
    }
  }

  @media all and (max-width: 768px) {
    padding: 0;
    justify-content: center;
    border-bottom: none;
    flex-direction: column;
    width: auto;
    i {
      margin: 0;
      margin-bottom: 8px;
      font-size: 24px;
    }
    p {
      font-size: 12px;
    }
  }
`;

export const NavItemDropdown = styled.div`
         display: flex;
         flex-direction: column;
         position: relative;
         align-items: center;
         z-index: 100;
         // align-self:
         // height: 80px;  always match the the navbar height for hover to work

         .dropdown {
           display: flex;
           flex-direction: row;
           align-items: center;
           cursor: pointer;
           height: 100%;
           min-height: 50px;
           width: 200px;
           img {
             height: 48px;
           }
           p {
             margin-bottom: 0;
             margin-left: 1em;
             text-transform: uppercase;
             font-style: italic;
             font-size: 18px;
           }
           i {
             font-size: 30px;
             color: #fff;
           }
           &:hover {
             p {
               color: #acff24;
             }
             i {
               color: #3ee9f7;
             }
           }
         }

         .dropdown-content-wrapper {
           display: none;
           position: absolute;
           flex-direction: column;
           align-items: center;
           justify-content: center;
           width: 180px;
           // height: 160px;
           top: 50px;
           padding: 1em;
           z-index: 1;

           .dropdown-pointer {
             width: 20px;
             height: 20px;
             transform: rotate(45deg);
             background-color: #2a2a2a;
             margin-bottom: -10px;
             position: relative;
             border: 1px solid #666;
             border-bottom: none;
             border-right: none;
           }

           .dropdown-content {
             display: flex;
             flex-direction: column;
             align-items: center;
             justify-content: space-around;
             min-width: 160px;
             width: 200px;
             min-height: 64px;
             height: 100%;
             background-color: #2a2a2a;
             padding: 0.5em 0;
             border-radius: 5px;
             border: 1px solid #666;

             p {
               // width: 100%;
               text-align: center;
               margin-bottom: 0;
               cursor: pointer;
               // margin: 8px;
             }
             p:hover {
               color: #acff24;
             }

             span {
               height: 1px;
               width: 100%;
               background-color: #888;
             }
           }
         }

         &:hover .dropdown-content-wrapper {
           display: flex;
         }

         @media all and (max-width: 768px) {
           .dropdown {
             padding: 0;
             justify-content: center;
             // border-bottom: 1px solid #999;
             display: flex;
             width: auto;
             flex-direction: column;
             align-items: center;

             i {
               font-size: 24px;
               margin: 0 0 8px 0;
             }
             p {
               font-size: 12px;
               text-align: center;
               margin-left: 0;
             }
           }

           .dropdown-pointer {
             display: unset;
             z-index: -1;
             border-left: 1px solid #999;
             border-top: 1px solid #999;
           }
           .dropdown-content-wrapper {
             //  top: 55px;
             padding: 12px;
             z-index: unset;
             display: none;

             .dropdown-content {
               min-height: unset;
               height: auto;
               border-left: 1px solid #999;
               border-right: 1px solid #999;
               border-bottom: 1px solid #999;
               border-top: 1px solid #999;
               width: 160px;

               & > * {
                 margin: 8px 0;
               }
             }
           }

           &:hover .dropdown-content-wrapper {
             display: flex;
           }
         }
       `;



// WEBPACK FOOTER //
// ./src/components/CustomNav/CustomNav.styles.ts